import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import {Moment} from 'moment';
import React from 'react';

import {CalendarInteraction, CalendarView} from 'calendar/CalendarConstants';
import {ElementMouseEvent} from 'util/Types';

import CalendarActions from './CalendarActions';
import CalendarUtil, {isDragCompleteInteraction, isDraggingInteraction} from './CalendarUtil';

interface Props {
  date: Moment;
  today: Moment;
  renderDate: (date: Moment) => JSX.Element;
  interact: CalendarInteraction;
  onMouseDown?: (e: ElementMouseEvent) => void;
  onMouseOver?: (e: ElementMouseEvent) => void;
}

class HeaderDate extends React.Component<Props> {
  getIsWithinMouseRange = (): boolean => {
    if (isDraggingInteraction(this.props.interact) || isDragCompleteInteraction(this.props.interact)) {
      // Find start/end date to determine if header is within range
      // (adds 1 day to endDate since it's exclusive)
      const [startDate, endDate] = CalendarUtil.rangeFromInteract(this.props.interact);
      return CalendarUtil.isDateBetween(this.props.date, startDate, endDate);
    }
    return false;
  };

  showDate = (): void => {
    CalendarActions.navigateDate(this.props.date);
    CalendarActions.changeView(CalendarView.DAY_VIEW);
  };

  override render(): JSX.Element {
    const isWithinMouseRange = this.getIsWithinMouseRange();
    return (
      <th
        key={this.props.date.format()}
        className="weekComponent-date"
        onMouseDown={this.props.onMouseDown}
        onMouseOver={this.props.onMouseOver}
      >
        <span
          onClick={this.showDate}
          className={classNames('weekComponent-date-text', {
            'is-today': this.props.date.isSame(this.props.today),
            'is-withinMouseRange': isWithinMouseRange,
          })}
          {...getTestProps({component: 'HeaderDate', element: 'date-text'})}
        >
          {this.props.renderDate(this.props.date)}
        </span>
      </th>
    );
  }
}

export default HeaderDate;
